<template>
    <div class="pkefu">
        <div class="brief-bg">
            <div class="brief-bg__word" :style="briefwordstyle">
                <h2 class="fadeInUp">在线客服系统</h2>
                <span class="fadeInUp">
                    加强商家与客户之间的沟通,是网络营销最重要的工具
                </span>
            </div>
            <img src="/site_static/pimg/banner-img.png" alt="" :style="briefimg">
        </div>
        <div class="itemOne">
            <div class="headerTitle">
                <p class="itemHeaderTitle">
                    提升服务价值，从这里开始
                </p>
            </div>
            <p>“匠心” 打造，注重产品功能打磨</p>
            <div class="itmeOneCon">
                <ul>
                    <li>
                        <img src="/site_static/pimg/img1.png" alt="">
                        <p  class="conTitle">功能更全面</p>
                        <div class="bar"><span></span></div>
                        <p class="conContent">多渠道部署</p>
                        <p class="conContent conContent1">满足多样化需求</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/img2.png" alt="">
                        <p  class="conTitle">管理更高效</p>
                        <div class="bar"><span></span></div>
                        <p class="conContent">智能化管理</p>
                        <p class="conContent conContent1">提高工作效率</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/img3.png" alt="">
                        <p  class="conTitle">服务更满意</p>
                        <div class="bar"><span></span></div>
                        <p class="conContent">洞察需求</p>
                        <p class="conContent conContent1">提升服务价值</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="itemList">
            <div  class="headerTitle">
                <div class="itemHeader">
                    <p  class="itemHeaderTitle">多渠道部署，满足多样化需求</p>
                </div>
            </div>
            <div>
                <div class="twoCon">
                    <ul>
                    <li>
                        <div></div>
                        <p>可接入微信公众号、APP、小程序、H5，多渠道部署，实现客服统一回复和处理</p>
                    </li>
                        <li>
                            <div></div>
                            <p>可支持文字、图片、语音、商品、订单、优惠券、二维码等对话方式，满足用户和客服之间多样化沟通需求</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="itemImg">
                <img alt="" src="/site_static/pimg/main_1.png">
            </div>
        </div>
        <div class="itemList">
            <div class="headerTitle">
                <div class="itemHeader">
                    <p class="itemHeaderTitle">智能化管理，提升工作效率</p>
                </div>
            </div>
            <div>
                <div class="twoCon">
                <ul>
                    <li>
                        <div></div>
                        <p >可设置自动回复、快捷语回复、客服管理等功能，提升客服工作能力，提高工作效率，让您的用户获得最优质的服务</p>
                    </li>
                    <li >
                        <div ></div>
                        <p >据客服状态自动分配任务；对会话消息进行排列、筛选；转接会员对话等功能，实现客服高效接待客户，提升用户满意度</p>
                    </li>
                </ul>
                </div>
            </div>
            <div  class="itemImg">
                <img  alt="" src="/site_static/pimg/main_2.png">
            </div>
        </div>
        <div class="itemList">
            <div class="headerTitle">
                <div class="itemHeader">
                    <p class="itemHeaderTitle">洞察需求，让运营更全面</p>
                </div>
            </div>
            <div>
                <div class="twoCon">
                    <ul>
                        <li>
                            <div></div>
                            <p>可查看会员信息、对话记录、满意度评价等信息，多维度了解客户状态和用户需求，针对性的进行沟通，让运营有效全面</p>
                        </li>
                        <li>
                            <div></div>
                            <p>商家可查看满意度评价、客服数据等信息，多维度了解客服工作状态，并定制相关工作计划，让运营更全面</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="itemImg1" class="itemImg">
                <img src="/site_static/pimg/main_3.png" alt="">
            </div>
        </div>
        <div class="itemThree">
            <div class="headerTitle">
                <div  class="itemHeader">
                    <p  class="itemHeaderTitle">手机聊天页面展示</p>
                </div>
                <p style="margin-top: .625rem; font-size: .69rem;text-align: center; color: #5d6494;">加强商家与用户之间关系，辅助商家销售，提升服务价值</p>
            </div>
            <mu-carousel hide-controls style="height: 24rem;">
                <mu-carousel-item>
                    <img src="/site_static/pimg/img7.png" style="width: 80%">
                </mu-carousel-item>
                <mu-carousel-item >
                    <img src="/site_static/pimg/img8.png" style="width: 80%">
                </mu-carousel-item>
            </mu-carousel>
        </div>
        <div class="itemFour">
            <div>
                <div  class="itemHeader">
                    <p class="itemHeaderTitle">功能展示</p>
                </div>
            </div>
            <div class="con">
                <ul>
                    <li data-v-44e025f8="">
                        <img src="/site_static/pimg/gn_1.png" >
                        <p>客服关联会员</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_2.png" >
                        <p>客服工作量设置</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_3.png">
                        <p>客服数据</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_4.png">
                        <p>智能回复</p>
                    </li>
                    <li data-v-44e025f8="">
                        <img src="/site_static/pimg/gn_4.png" >
                        <p data-v-44e025f8="">满意度评价</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_4.png" >
                        <p>会员信息</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_4.png" >
                        <p>不同类型消息</p>
                    </li>
                    <li>
                        <img src="/site_static/pimg/gn_4.png" >
                        <p>客服分组</p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="fooder">
            <div class="logo">
                <img src="../../../assets/phoneimg/nav_logo.png" alt="">
            </div>
            <div class="body">
                <ul>
                    <li>国际顶级域名</li>
                    <li>出版物经营许可证</li>
                    <li>广播电视节目制作经营许可证</li>
                    <li>开户许可证</li>
                    <li>食品经营许可证</li>
                    <li>计算机软件著作权证书</li>
                    <li>网络文化经营许可证</li>
                    <li>营业执照</li>
                    <li>增值电信业务许可证</li>
                </ul>
            </div>
            <div class="last">
                <span>微涟科技有限公司版权所有</span>
                <span>©辽ICP备18009739号</span>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'pkefu',
        data(){
        return{
            briefwordstyle:{},
            briefimg:{},
            pageh:{}
        }
    },
    created() {
        let self = this
        setTimeout(function () {
            self.briefwordstyle={
                opacity: 1,
                bottom: '3rem'
            }
            self.briefimg={
                opacity: 1,
                bottom: '1rem'
            }
            self.pageh={
                opacity: 1,
                bottom: 0
            }
        },0)
    }
    }
</script>
<style scoped>
    p{
        text-align: left;
    }
    ul{
        list-style: none;
        padding: 0;
    }
    .pkefu{
        margin-top: 3rem;
    }
    .brief-bg{
        width: 100%;
        height: 10.9375rem;
        position: relative;
        background: url("/site_static/pimg/banner-bg.png") no-repeat;
        overflow: hidden;
    }
    .brief-bg>.brief-bg__word{
        position: absolute;
        width: 11.25rem;
        left: 1.25rem;
        bottom: 0rem;
        color: #fff;
        opacity: 0;
        transition: all .5s;
    }
    .brief-bg>.brief-bg__word>h2{
        line-height: 1.125rem;
        font-weight: 600;
        font-size: 1.125rem;
        color: #fff;
        margin-bottom: 1.25rem;
    }
    .brief-bg>.brief-bg__word>span {
        font-size: .75rem;
        color: hsla(0,0%,100%,.8);
        line-height: 1.3125rem;
    }
    .brief-bg>img{
        width: 8.0625rem;
        position: absolute;
        bottom: 0rem;
        right: 1.25rem;
        opacity: 0;
        transition: all .5s;
    }
    .page-info{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .page-info>h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
        position: relative;
        bottom: -2rem;
        transition: all .5s;
        opacity: 0;
    }
    .page-info>h3{
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
        position: relative;
        bottom: -2rem;
        transition: all 1s;
    }
    .fooder{
        width: 100%;
        overflow: hidden;
        background: #1c1c24;
        position: relative;
    }
    .logo{
        width: 20.9375rem;
        margin: auto;
        height: 4.96875rem;
        position: relative;
        margin-left: 2rem;
    }
    .logo>img{
        width: 14.25rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: auto;
    }
    .body{
        width: 100%;
        box-sizing: border-box;
        margin: auto;
    }
    .body>ul{
        width: 100%;
        margin-bottom: 1.5rem;
        overflow: hidden;

    }
    .body li{
        margin: 0 1.1875rem 0 0;
        font-size: .75rem;
        color: #888;
        line-height: .75rem;
        width: calc(33% - 1rem);
        float: left;
        margin:  .5rem;
    }
    .last{
        width: 20.9375rem;
        margin: auto;
        height: 4.125rem;
        box-sizing: border-box;
        border-top: 1px solid hsla(0,0%,100%,.1);
        padding: 1.125rem 0 0 0;
        margin-bottom: 3rem;
    }
    .last>span{
        display: block;
        font-size: .625rem;
        color: #3d404d;
        line-height: 1rem;
        text-align: center;
    }
    .itemOne{
        background-color: #f5f8ff;
        padding-top: 2.5rem;
        min-height: 18.75rem;
    }
    .headerTitle>.itemHeaderTitle {
        font-size: 1.125rem;
        text-align: center;
        color: #5d6494;
        font-weight: 600;
    }
    .itemOne p {
        margin-top: .46875rem;
        font-size: .75rem;
        text-align: center;
        color: #5d6494;
    }
    .itemOne .itmeOneCon{
        width: 100%;
        margin-top: 1.25rem;
        padding-bottom: 1.25rem;
    }
    .itemOne .itmeOneCon ul {
        overflow: hidden;
        margin: 0 auto;
        text-align: center;
    }
    .itemOne .itmeOneCon ul li {
        float: left;
        width: 30%;
        text-align: center;
        background-color: #fff;
        padding-top: .8125rem;
        padding-bottom: .625rem;
        margin-left: .625rem;
    }
    .itemOne .itmeOneCon ul li img {
        max-width: 80%;
    }
    .itemOne .itmeOneCon ul li .conTitle {
        font-size: .94rem;
        color: #3b426b;
        margin-top: .5rem;
        font-weight: 500;
    }
    .itemOne .itmeOneCon ul li .bar {
        text-align: center;
        margin-top: -.3125rem;
    }
    .itemOne .itmeOneCon ul li .bar span {
        display: inline-block;
        width: 1.5625rem;
        height: .125rem;
        border-radius: .0625rem;
        background-color: #6f52fe;
    }
    .itemOne .itmeOneCon ul li .conContent {
        font-size: .69rem;
        font-weight: 300;
    }
    .itemOne .itmeOneCon ul li .conContent1 {
        margin-top: -.3125rem;
    }
    .itemList{
        padding-top: 2.5rem;
    }
    .itemHeader>.itemHeaderTitle {
        font-size: 1.125rem;
        text-align: center;
        color: #5d6494;
        font-weight: 600;
    }
    .twoCon {
        width: 100%;
        margin-top: 1.5625rem;
    }
    .twoCon ul {
        width: 85%;
        margin: 0 auto;
    }
    .twoCon ul li {
        padding-bottom: .5625rem;
        overflow: hidden;
    }
    .twoCon ul li div {
        width: .375rem;
        height: .375rem;
        background-color: #3544f3;
        border-radius: 50%;
    }
    .twoCon ul li p {
        margin: 0;
        padding: 0;
        display: inline-block;
        font-size: .69rem;
        color: #7b88a2;
        margin-left: .75rem;
        margin-top: -.5625rem;
        line-height: 1.125rem;
    }
    .itemList .itemImg {
        margin-top: .75rem;
        text-align: center;
    }
    .itemList .itemImg img {
        max-width: 80%;
    }
    .itemThree {
        background-color:#e3f2fd;
        padding-top: 2.5rem;
    }
    .itemFour {
        padding-top: 2.5rem;
    }
    .itemHeader>.itemHeaderTitle {
        font-size: 1.125rem;
        text-align: center;
        color: #5d6494;
        font-weight: 600;
    }
    .itemFour .con {
        padding-bottom: 1.5625rem;
    }
    .itemFour .con ul{
        width: 100%;
        margin-top: 1.25rem;
        overflow: hidden;
    }
    .itemFour .con ul li {
        width: 25%;
        text-align: center;
        float: left;
        padding-bottom: 1.25rem;
    }
    .itemFour .con ul li img{
        width: 70%;
    }
    .itemFour .con ul li p {
         font-size: .56rem;
         color: #3b426b;
         margin-top: .375rem;
        text-align: center;
     }
</style>



// WEBPACK FOOTER //
// src/components/phone/ppro/pkefu.vue